import React, { useRef, useState, useEffect } from "react";
import {
  Badge,
  Button,
  Col,
  Container,
  Form,
  Table,
  InputGroup,
  ListGroup,
  Pagination,
  Nav,
  Row,
  Tab,
  Modal,
} from "react-bootstrap";
import { NavLink } from "react-router-dom";
import calendar from "../../../assets/images/icons/calendar.png";
import dummy_coach1_sqr from "../../../assets/images/dummy/dummy_coach1_sqr.png";
import { Rating } from "react-simple-star-rating";
import qs from "qs";

import axios from "axios";

import "./Calendar.css";
import { Scheduler } from "@aldabil/react-scheduler";
import {
  cancelSession,
  changeProgramSessionStatus,
  getCoachBookedSlots,
} from "../../../utils/api";
import Lottie from "react-lottie";
import noDataLottie from "../../../assets/lottieFiles/noData.json";
import moment from "moment";
import AgoraComponent from "../../../Front/Pages/agora/livestream";
import { api } from "../../../utils/api/axios";
import { toast } from "react-toastify";
import { truncateString } from "../../../utils/functions";
import { useUserContext } from "../../../utils/hooks/UserContext";

// const EVENTS = [
//   {
//     event_id: 1,
//     title: "Event 1",
//     start: new Date(new Date(new Date().setHours(9)).setMinutes(0)),
//     end: new Date(new Date(new Date().setHours(10)).setMinutes(0)),
//     disabled: true,
//     admin_id: [1, 2, 3, 4],
//   },
//   {
//     event_id: 2,
//     title: "Event 2",
//     start: new Date(new Date(new Date().setHours(10)).setMinutes(0)),
//     end: new Date(new Date(new Date().setHours(12)).setMinutes(0)),
//     admin_id: 2,
//     color: "#50b500",
//   },
//   {
//     event_id: 3,
//     title: "Event 3",
//     start: new Date(new Date(new Date().setHours(11)).setMinutes(0)),
//     end: new Date(new Date(new Date().setHours(12)).setMinutes(0)),
//     admin_id: 1,
//     editable: false,
//     deletable: false,
//   },
//   {
//     event_id: 4,
//     title: "Event 4",
//     start: new Date(
//       new Date(new Date(new Date().setHours(9)).setMinutes(30)).setDate(
//         new Date().getDate() - 2
//       )
//     ),
//     end: new Date(
//       new Date(new Date(new Date().setHours(11)).setMinutes(0)).setDate(
//         new Date().getDate() - 2
//       )
//     ),
//     admin_id: 2,
//     color: "#900000",
//   },
//   {
//     event_id: 5,
//     title: "Event 5",
//     start: new Date(
//       new Date(new Date(new Date().setHours(10)).setMinutes(30)).setDate(
//         new Date().getDate() - 2
//       )
//     ),
//     end: new Date(
//       new Date(new Date(new Date().setHours(14)).setMinutes(0)).setDate(
//         new Date().getDate() - 2
//       )
//     ),
//     admin_id: 2,
//     editable: true,
//   },
//   {
//     event_id: 6,
//     title: "Event 6",
//     start: new Date(
//       new Date(new Date(new Date().setHours(10)).setMinutes(30)).setDate(
//         new Date().getDate() - 4
//       )
//     ),
//     end: new Date(new Date(new Date().setHours(14)).setMinutes(0)),
//     admin_id: 2,
//   },
// ];
const baseURL = `${process.env.REACT_APP_LOCAL_BASE_URL}`;

const BookingComponent = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: noDataLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const [userTimeZone, setUserTimeZone] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );
  function formatDuration(minutes) {
    const days = Math.floor(minutes / 1440); // 1440 minutes in a day
    const remainingAfterDays = minutes % 1440;
    const hours = Math.floor(remainingAfterDays / 60);
    const mins = remainingAfterDays % 60;

    const parts = [];

    if (days > 0) parts.push(`${days} days `);
    if (hours > 0) parts.push(`${hours} hours `);
    if (mins > 0) parts.push(`${mins} mins`);

    // If all are zero, return "0m" or handle as needed
    return parts.length > 0 ? parts.join(" ") : "0 mins";
  }
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [events, setEvents] = useState([
    { date: "2024-08-20", name: "Meeting", time: "10:00 AM" },
    { date: "2024-08-22", name: "Conference", time: "02:00 PM" },
    // Add more events as needed
  ]);
  const [visible, setVisible] = useState(false);

  const [bookedEvents, setBookedEvents] = useState([]);
  const [myClientList, setMyClientList] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [programType, setProgramType] = useState("");
  const [feedbackList, setFeedbackList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [feedbackModalIsOpen, setFeedbackModalIsOpen] = useState(false);

  const handleGetProgramFeedback = async (selectedSessionId) => {
    try {
      const payload = {
        program_id: selectedSessionId,
        page: currentPage,
        limit: 10,
      };
      const response = await api(`reviews?${qs.stringify(payload)}`, "GET");
      if (response.data.success === true) {
        const pagination = response.data.pagination;
        setFeedbackList(response.data.data);
        setTotalPages(pagination.totalPages);
        setCurrentPage(pagination.currentPage);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(`Something went wrong! ${error.message}`);
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const getListData = async () => {
    try {
      const data = await getCoachBookedSlots();
      console.log(data.data.data, "data");
      setBookedEvents(data.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (
      feedbackList &&
      Array.isArray(feedbackList) &&
      feedbackList.length > 0
    ) {
      handleGetProgramFeedback(feedbackList[0].program_id);
    }
  }, [currentPage]);

  useEffect(() => {
    getListData();
    allClients();
  }, []);

  // Handle date change
  const handleStartDateChange = (e) => setStartDate(e.target.value);
  const handleEndDateChange = (e) => setEndDate(e.target.value);

  // Filter events between start and end dates
  const filteredEvents = events.filter((event) => {
    const eventDate = new Date(event.date);
    return (
      (!startDate || eventDate >= new Date(startDate)) &&
      (!endDate || eventDate <= new Date(endDate))
    );
  });

  // Render the table
  // const renderTable = () => {
  //   if (!startDate || !endDate)
  //     return <p>Select a date range to see events.</p>;

  //   return (
  //     <table>
  //       <thead>
  //         <tr>
  //           <th>Date</th>
  //           <th>Event Name</th>
  //           <th>Event Time</th>
  //         </tr>
  //       </thead>
  //       <tbody>
  //         {filteredEvents.map((event, index) => (
  //           <tr key={index}>
  //             <td>{event.date}</td>
  //             <td>{event.name}</td>
  //             <td>{event.time}</td>
  //           </tr>
  //         ))}
  //       </tbody>
  //     </table>
  //   );
  // };

  const allClients = async () => {
    try {
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
          "Cache-Control":
            "no-store, no-cache, must-revalidate, proxy-revalidate",
        },

        url: `${baseURL}/coach/program/coach-clients-list`,
      };
      axios(options).then((resp) => {
        // console.log(resp, "resp");
        setMyClientList(resp.data.data);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleClientFIlter = (e) => {
    try {
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
          "Cache-Control":
            "no-store, no-cache, must-revalidate, proxy-revalidate",
        },

        url: `${baseURL}/coach/program/coach-scheduled-list?client_id=${e}&status=${selectedStatus}&program_type=${programType}`,
      };
      axios(options).then((resp) => {
        // console.log(resp, "resp");
        // setMyClientList(resp.data.data);
        setBookedEvents(resp.data.data);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleStatusFilter = async (status) => {
    try {
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
          "Cache-Control":
            "no-store, no-cache, must-revalidate, proxy-revalidate",
        },

        url: `${baseURL}/coach/program/coach-scheduled-list?client_id=${selectedClient}&status=${status}&program_type=${programType}`,
      };
      axios(options).then((resp) => {
        // console.log(resp, "filter");
        setBookedEvents(resp.data.data);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleProgramFilter = async (type) => {
    try {
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
          "Cache-Control":
            "no-store, no-cache, must-revalidate, proxy-revalidate",
        },

        url: `${baseURL}/coach/program/coach-scheduled-list?client_id=${selectedClient}&status=${selectedStatus}&program_type=${type}`,
      };
      axios(options).then((resp) => {
        // console.log(resp, "filter");
        setBookedEvents(resp.data.data);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const timer = setInterval(() => {
      const updatedTimeLeft = bookedEvents.reduce((acc, item) => {
        // Parse start_time as UTC and convert to user's timezone
        const adjustedTime = moment.utc(item.start_time).tz(userTimeZone);

        // Get current time in user's timezone
        const now = moment().tz(userTimeZone);

        console.log(adjustedTime.format(), now.format(), "Adjusted vs Now");

        // Calculate the difference
        const durationInMilliseconds = adjustedTime.diff(now);
        const duration = moment.duration(durationInMilliseconds);

        // Calculate cumulative hours and minutes
        const totalHours = Math.floor(duration.asHours());
        console.log("durations", duration, totalHours);

        // Total hours (including days)
        const hours = totalHours % 24; // Remaining hours
        const minutes = Math.floor(duration.asMinutes() % 60); // Remaining minutes

        acc[item.id] = {
          days: Math.floor(totalHours / 24), // Whole days
          hours: Math.max(0, hours), // Remaining hours
          minutes: Math.max(0, minutes), // Remaining minutes
        };
        return acc;
      }, {});

      setTimeLeft(updatedTimeLeft);
    }, 1000);

    return () => clearInterval(timer);
  }, [bookedEvents]);

  // AGORA HOOKS
  const [videoCallSessionId, setVideoCallSessionId] = useState("");
  const [videoCallSessionName, setVideoCallSessionName] = useState("");
  const [videoCall, setVideocall] = useState(false);
  const [sessionDetails, setSessionDetails] = useState({});

  async function showSessionInterest(id, name, details) {
    const payload = {
      session_status: "live",
      id,
    };
    await changeProgramSessionStatus(payload);
    console.log("function called", details);
    setVideoCallSessionId(id);
    setVideoCallSessionName(name);
    setSessionDetails(details);
    setVideocall(true);
  }

  const { fetchNotifications } = useUserContext();

  useEffect(() => {
    console.log("notiiiiion");
    fetchNotifications();
  }, []);
  const [sessionData, setSessionData] = useState(null);
  const cancelSessions = async () => {
    try {
      console.log(sessionData);
      let data = {
        availability_slot_id: sessionData?.available_slot_id,
        session_slot_id: sessionData?.id,
        program_id: sessionData?.program_id,
        userType: "coach",
      };

      const resp = await cancelSession(data);
      console.log("herererer", resp);
      if (resp.status) {
        getListData();
        fetchNotifications();
        toast.success(resp?.message || "session cancelled successfully.");
        setVisible(false);
      } else {
        toast.error("session not cacelled");
      }
    } catch (error) {}
  };
  return (
    <>
      <section className="coach_my_activity py-3">
        <div className="">
          <div className="date-selectors d-flex">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <InputGroup className="mb-3">
                <Form.Control
                  type="date"
                  value={startDate || ""}
                  onChange={handleStartDateChange}
                  className="calender"
                />
                <InputGroup.Text>to</InputGroup.Text>
                <Form.Control
                  type="date"
                  value={startDate || ""}
                  className="calender"
                  onChange={handleEndDateChange}
                />
              </InputGroup>
            </Form.Group>
            <div className="text-end ms-4">
              <NavLink to={"/coach/add-availability"}>
                <Button className="px-4" variant="success">
                  Add Availability
                </Button>
              </NavLink>
            </div>
          </div>
        </div>
        <Row className="mb-3 align-items-center">
          <Col xs="4">
            <div className="text-start hdng_a">
              <h2 className="m-0">My Booking</h2>
            </div>
          </Col>
          <Col>
            <Row className="gx-2 align-items-center">
              <Col>
                <Form.Select
                  onChange={(e) => {
                    setSelectedClient(e.target.value);
                    handleClientFIlter(e.target.value);
                  }}
                >
                  <option value="">Clients</option>
                  {myClientList.map((item) => (
                    <option value={item.user_id}> {item.user_name} </option>
                  ))}
                </Form.Select>
              </Col>
              <Col>
                <Form.Select
                  onChange={(e) => {
                    setSelectedStatus(e.target.value);
                    handleStatusFilter(e.target.value);
                  }}
                >
                  <option value="">Status</option>
                  <option value="scheduled">Scheduled</option>
                  <option value="pending">Pending</option>
                  <option value="completed">Completed</option>
                  <option value="cancelled">Cancelled</option>
                </Form.Select>
              </Col>
              <Col>
                <Form.Select
                  onChange={(e) => {
                    setProgramType(e.target.value);
                    handleProgramFilter(e.target.value);
                  }}
                >
                  <option value="">Program Type</option>
                  <option value="single">Single Day</option>
                  <option value="multiple">MultiDay</option>
                </Form.Select>
              </Col>
              {/*  <Col xs="auto">
                <div className="d-flex">
                  <Button className="pe-0" variant="link">
                    <i className="text_brand_color2 fs-30 bi bi-calendar-week-fill"></i>
                  </Button>
                  <Button className="pe-0" variant="link">
                    <i className="text_brand_color2 fs-30 bi bi-list-task"></i>
                  </Button>
                </div>
              </Col> */}
            </Row>
          </Col>
        </Row>

        <div className="booking-component">
          <ul className="booking_user_list">
            {bookedEvents.length > 0 ? (
              bookedEvents.map((item) => {
                // Parse and format the end time
                // item.start_time = moment(item.start_time, "YYYY-MM-DD HH:mm:ss")
                //   .subtract(30, "minutes")
                //   .subtract(5, "hours")
                //   .format('YYYY-MM-DD HH:mm:ss');

                //   item.end_time = moment(item.end_time, "YYYY-MM-DD HH:mm:ss")
                //   .add(30, "minutes")
                //   .add(5, "hours")
                //   .format('YYYY-MM-DD HH:mm:ss');
                // const adjustedTime = moment.utc(item.start_time);
                // const formattedStartTime = adjustedTime.format(
                //   "MMMM Do YYYY, h:mm A"
                // );

                // const adjustedEndTime = moment.utc(item.end_time);

                // const formattedEndTime = adjustedEndTime.format("h:mm A");
                // const startTime = moment(
                //   moment(adjustedTime).format("YYYY-MM-DD HH:mm"),
                //   "YYYY-MM-DD HH:mm"
                // );
                // const endTime = moment(
                //   moment(adjustedEndTime).format("YYYY-MM-DD HH:mm"),
                //   "YYYY-MM-DD HH:mm"
                // );
                // const currentTime = moment().format("YYYY-MM-DD HH:mm");

                // const durationInMinutes = startTime.diff(
                //   currentTime,
                //   "minutes"
                // );

                const adjustedTime = moment
                  .utc(item.start_time)
                  .tz(userTimeZone);
                const adjustedEndTime = moment
                  .utc(item.end_time)
                  .tz(userTimeZone);

                const formattedStartTime = adjustedTime.format(
                  "MMMM Do YYYY, HH:mm A"
                );
                const formattedEndTime = adjustedEndTime.format(
                  "MMMM Do YYYY, HH:mm A"
                );
                // Format start and end times
                const now = moment().tz(userTimeZone);

                const isWithinTimeRange =
                  moment(adjustedTime).format("YYYY-MM-DD HH:mm:ss") <
                    now.format("YYYY-MM-DD HH:mm:ss") &&
                  moment(adjustedEndTime).format("YYYY-MM-DD HH:mm:ss") >
                    now.format("YYYY-MM-DD HH:mm:ss");

                // const isExpiredTimeRange =
                //   moment(adjustedEndTime).format("YYYY-MM-DD HH:mm:ss") <
                //     now.format("YYYY-MM-DD HH:mm:ss");

                const isExpiredTimeRange =
                  moment(adjustedEndTime).isBefore(now);
                // Calculate duration in minutes using moment.utc
                const startTime = moment.utc(
                  adjustedTime.format("YYYY-MM-DD HH:mm"),
                  "YYYY-MM-DD HH:mm"
                );
                const endTime = moment.utc(
                  adjustedEndTime.format("YYYY-MM-DD HH:mm"),
                  "YYYY-MM-DD HH:mm"
                );
                const durationInMinutes = endTime.diff(startTime, "minutes");

                // Get remaining time for this session
                const remainingTime = timeLeft[item.id] || {
                  days: 0,
                  hours: 0,
                  minutes: 0,
                };
                const formattedDuration = formatDuration(durationInMinutes);
                return (
                  <li key={item.id}>
                    <div className="booking_user_card">
                      <Row className="align-items-center">
                        <Col sm="6">
                          <div className="p-2 booking_user_card_lt">
                            <div className="d-flex align-items-center">
                              <img
                                className="user_img border rounded-circle p-1"
                                src={
                                  item.user_profile
                                    ? `${process.env.REACT_APP_USER_PROFILE_FOLDER_PATH}${item.user_profile}`
                                    : dummy_coach1_sqr
                                }
                                alt="User Profile"
                              />
                              <div className="ps-2">
                                <h5>{item.user_name}</h5>
                                {item.session_day_status === "scheduled" && (
                                  <p>
                                    {formattedStartTime +
                                      " to " +
                                      formattedEndTime}

                                    {/* {`${moment(item.start_time).format('dddd')}, ${moment(item.start_time).format('DD')} ${moment(item.start_time).format('MMM')} ${moment(item.start_time).format('YYYY')}, ${moment(item.start_time).format('HH:mm A')} to ${moment(item.end_time).format('HH:mm A')}`} */}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col sm="6">
                          <div
                            className="p-2 booking_user_card_rt"
                            style={{ background: "#F5F5F5" }}
                          >
                            <span className="u_id"></span>
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <h5>{item.program_title}</h5>
                              {item.session_day_status === "completed" ? (
                                <div className="d-flex flex-column gap-2">
                                  <span
                                    variant="success"
                                    className="batch-completed text-center"
                                  >
                                    Completed
                                  </span>
                                  {item?.session_day_status?.toLowerCase() ===
                                    "completed" && (
                                    <Button
                                      className="feedback-btn d-flex align-items-center"
                                      variant="outline-success"
                                      style={{
                                        borderRadius: "10px",
                                        padding: "6px 10px",
                                        fontWeight: "500",
                                        borderWidth: "1.5px",
                                        fontSize: "12px",
                                        fontWeight: "700",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                        transition: "all 0.3s ease",
                                      }}
                                      onClick={() => {
                                        setFeedbackModalIsOpen(
                                          !feedbackModalIsOpen
                                        );
                                        handleGetProgramFeedback(
                                          item.program_id
                                        );
                                      }}
                                    >
                                      <i className="bi fw-bold bi-chat-square-text me-2"></i>
                                      Feedback
                                    </Button>
                                  )}
                                </div>
                              ) : isWithinTimeRange ? (
                                <Button
                                  onClick={() =>
                                    showSessionInterest(
                                      item.id,
                                      item.program_title,
                                      item
                                    )
                                  }
                                  className="batch-start-btn"
                                  variant="success"
                                >
                                  {" "}
                                  Start Session
                                </Button>
                              ) : isExpiredTimeRange ? (
                                <div className="ml-4">
                                  <span className="batch-not-started">
                                    Expired
                                  </span>
                                  {/* <span variant="success" className="batch-completed text-center ml-1">Reschedule Session</span> */}
                                </div>
                              ) : (
                                <div>
                                  <span className="batch-not-started">
                                    Not Started
                                  </span>
                                  <span
                                    className="bg-red-500 text-white rounded-[5px] p-2 ml-1 cursor-pointer"
                                    onClick={() => {
                                      setSessionData(item);
                                      setVisible(true);
                                    }}
                                  >
                                    Cancel Session
                                  </span>
                                </div>
                              )}
                            </div>
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <div className="d-flex align-items-center">
                                <p className="">{item.session_name}</p>
                              </div>
                              {/* {durationInMinutes > 0 && (
                                <span>{remainingTime} left</span>
                              )} */}
                              <div className="countdown">
                                {remainingTime.days > 0 && (
                                  <span>{remainingTime.days} Days </span>
                                )}
                                {remainingTime.hours > 0 && (
                                  <span>{remainingTime.hours} Hours </span>
                                )}
                                {remainingTime.minutes > 0 && (
                                  <span>
                                    {remainingTime.minutes} Minutes left
                                  </span>
                                )}
                              </div>
                              {/* <span>{durationInMinutes} minutes</span> */}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </li>
                );
              })
            ) : (
              <Col>
                <Lottie
                  options={defaultOptions}
                  height={300}
                  width={400}
                  isStopped={false}
                  isPaused={false}
                />
              </Col>
            )}

            {/* <li>
            <div className="booking_user_card">
              <Row className="align-items-center">
                <Col sm="6">
                    <div className="p-2 booking_user_card_lt">
                      <div className="d-flex align-items-center">
                        <img className="user_img" src={dummy_coach1_sqr} />
                        <div className="ps-2">
                          <h5>Jatin Mishra</h5>
                          <p>Saturday, 1st Aug 2024, 9:00 to 9:30</p>
                        </div>
                      </div>
                    </div>
                </Col>
                <Col sm="6">
                    <div className="p-2 booking_user_card_rt" style={{background: '#CCDCDC'}}>
                      <span className="u_id">EICC25421</span>
                      <div className="mb-2 d-flex justify-content-between align-items-center w-100">
                        <h5>Emotional Intelligence complete c...</h5>
                        <Button variant="cancle-session" className="">Cancle</Button>
                      </div>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex align-items-center">
                          <span className="u_id">EICC254212</span>
                          <p className="ms-4">Basic Emotional Intelligence</p>
                        </div>
                        <span className="">30 minutes</span>
                      </div>
                    </div>
                </Col>
              </Row>
            </div>
          </li>

          <li>
            <div className="booking_user_card">
              <Row className="align-items-center">
                <Col sm="6">
                    <div className="p-2 booking_user_card_lt">
                      <div className="d-flex align-items-center">
                        <img className="user_img" src={dummy_coach1_sqr} />
                        <div className="ps-2">
                          <h5>Jatin Mishra</h5>
                          <p>Saturday, 1st Aug 2024, 9:00 to 9:30</p>
                        </div>
                      </div>
                    </div>
                </Col>
                <Col sm="6">
                    <div className="p-2 booking_user_card_rt" style={{background: '#964B0033'}}>
                      <span className="u_id">EICC25421</span>
                      <div className="mb-2 d-flex justify-content-between align-items-center w-100">
                        <h5>Emotional Intelligence complete c...</h5>
                        <Button variant="cancle-session" className="">Cancle</Button>
                      </div>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex align-items-center">
                          <span className="u_id">EICC254212</span>
                          <p className="ms-4">Basic Emotional Intelligence</p>
                        </div>
                        <span className="">30 minutes</span>
                      </div>
                    </div>
                </Col>
              </Row>
            </div>
          </li>
          <li>
            <div className="booking_user_card">
              <Row className="align-items-center">
                <Col sm="6">
                    <div className="p-2 booking_user_card_lt">
                      <div className="d-flex align-items-center">
                        <img className="user_img" src={dummy_coach1_sqr} />
                        <div className="ps-2">
                          <h5>Jatin Mishra</h5>
                          <p>Saturday, 1st Aug 2024, 9:00 to 9:30</p>
                        </div>
                      </div>
                    </div>
                </Col>
                <Col sm="6">
                    <div className="p-2 booking_user_card_rt" style={{background: '#CCDCDC'}}>
                      <span className="u_id">EICC25421</span>
                      <div className="mb-2 d-flex justify-content-between align-items-center w-100">
                        <h5>Emotional Intelligence complete c...</h5>
                        <Button variant="cancle-session" className="">Cancle</Button>
                      </div>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex align-items-center">
                          <span className="u_id">EICC254212</span>
                          <p className="ms-4">Basic Emotional Intelligence</p>
                        </div>
                        <span className="">30 minutes</span>
                      </div>
                    </div>
                </Col>
              </Row>
            </div>
          </li>

          <li>
            <div className="booking_user_card">
              <Row className="align-items-center">
                <Col sm="6">
                    <div className="p-2 booking_user_card_lt">
                      <div className="d-flex align-items-center">
                        <img className="user_img" src={dummy_coach1_sqr} />
                        <div className="ps-2">
                          <h5>Jatin Mishra</h5>
                          <p>Saturday, 1st Aug 2024, 9:00 to 9:30</p>
                        </div>
                      </div>
                    </div>
                </Col>
                <Col sm="6">
                    <div className="p-2 booking_user_card_rt" style={{background: '#CCDCDC'}}>
                      <span className="u_id">EICC25421</span>
                      <div className="mb-2 d-flex justify-content-between align-items-center w-100">
                        <h5>Emotional Intelligence complete c...</h5>
                        <Button variant="cancle-session" className="">Cancle</Button>
                      </div>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex align-items-center">
                          <span className="u_id">EICC254212</span>
                          <p className="ms-4">Basic Emotional Intelligence</p>
                        </div>
                        <span className="">30 minutes</span>
                      </div>
                    </div>
                </Col>
              </Row>
            </div>
          </li> */}
          </ul>
        </div>

        <Container>
          {/* <div>
        <Scheduler
        events={EVENTS}
        disableViewer
        onEventClick={() => {
          console.log("onEventClick");
        }}
      />
      </div> */}
          {videoCall ? (
            <AgoraComponent
              videoCallSessionId={videoCallSessionId}
              videoCallSessionName={videoCallSessionName}
              sessionDetails={sessionDetails}
            />
          ) : (
            ""
          )}
        </Container>
        {/* <Container>
        <div className="booking-component">
          <div className="table-container">
            {renderTable()}
          </div>
        </div>
      </Container> */}
      </section>
      {console.log("feedbackList", feedbackList)}
      <Modal
        show={feedbackModalIsOpen}
        onHide={() => {
          setFeedbackModalIsOpen(false);
        }}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Review and Feedback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Table responsive>
              <thead>
                <tr>
                  <th>Reviewer Name</th>
                  <th>Coach Name</th>
                  <th>Rating</th>
                  <th>Description</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                {feedbackList.map((feedback) => (
                  <tr key={feedback.id}>
                    <td>{feedback.reviewerName}</td>
                    <td>{feedback.coachName}</td>
                    <td>
                      <Rating initialValue={feedback.rating} readonly={true} />
                    </td>
                    <td>{truncateString(feedback.description, 50)}</td>
                    <td>{moment(feedback.createdAt).format("DD-MMM-YYYY")}</td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <Container>
              {totalPages > 1 && (
                <Pagination className="justify-content-center flex-wrap">
                  <Pagination.First
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                  />
                  <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  />

                  {/* Show first page always */}
                  <Pagination.Item
                    active={1 === currentPage}
                    onClick={() => handlePageChange(1)}
                  >
                    1
                  </Pagination.Item>

                  {/* Show ellipsis if needed */}
                  {currentPage > 3 && <Pagination.Ellipsis disabled />}

                  {/* Show pages around current page */}
                  {[...Array(totalPages)]
                    .map((_, i) => i + 1)
                    .filter(
                      (page) =>
                        page === currentPage ||
                        page === currentPage - 1 ||
                        page === currentPage + 1 ||
                        page === totalPages
                    )
                    .filter((page) => page > 1 && page < totalPages)
                    .map((page) => (
                      <Pagination.Item
                        key={page}
                        active={page === currentPage}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </Pagination.Item>
                    ))}

                  {/* Show ellipsis if needed */}
                  {currentPage < totalPages - 2 && (
                    <Pagination.Ellipsis disabled />
                  )}

                  {/* Show last page always if different from first */}
                  {totalPages > 1 && (
                    <Pagination.Item
                      active={totalPages === currentPage}
                      onClick={() => handlePageChange(totalPages)}
                    >
                      {totalPages}
                    </Pagination.Item>
                  )}

                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  />
                  <Pagination.Last
                    onClick={() => handlePageChange(totalPages)}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              )}
            </Container>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="button"
            variant="secondary"
            onClick={() => {
              setFeedbackModalIsOpen(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={visible} onHide={() => setVisible(false)} centered>
        <Modal.Body>
          <div className="text-center">
            <p>
              {" "}
              Are you sure <br />
              You want to cancel this session{" "}
            </p>
            <div className="mt-4 logout_button_container">
              <button
                className="p-2 rounded btn-success me-3"
                onClick={() => {
                  cancelSessions();
                }}
              >
                {" "}
                <h5 className="px-4 m-0 fs-14 fw-400">Yes</h5>{" "}
              </button>
              <button
                className="p-2 text-white border-0 rounded btn-success bg-secondary"
                onClick={() => setVisible(false)}
              >
                {" "}
                <h5 className="px-4 m-0 fs-14 fw-400">No</h5>{" "}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BookingComponent;
